export default "__VITE_ASSET__q0_mX5ET__"